import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronTop, IconChevronBottom } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { ActionLink } from '../../../../../../../../../../../../primitives/index.js';
export const Controls = ({
  expanded,
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return _jsx(ActionLink, {
    size: "medium",
    bold: true,
    onClick: onClick,
    "data-testid": "expand",
    children: expanded ? _jsxs(_Fragment, {
      children: [t('airportsWidget:showFewerAirports'), _jsx(IconChevronTop, {})]
    }) : _jsxs(_Fragment, {
      children: [t('airportsWidget:showMoreAirports'), _jsx(IconChevronBottom, {})]
    })
  });
};